import {useState} from 'react';
import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {RecordsTable} from "../tables/RecordsTable.tsx";
import {SetupIntent} from '../types';

export const IndexPage = () => {
    const [selectedRecords, setSelectedRecords] = useState<SetupIntent[]>([]);

    const selectedIds = selectedRecords.map(r => r.id);

    const handleDeleteComplete = () => {
        setSelectedRecords([]);
    };

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader selectedIds={selectedIds} onDeleteComplete={handleDeleteComplete}/>}
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordsTable
                    selectedRecords={selectedRecords}
                    setSelectedRecords={setSelectedRecords}
                />
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
